/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { userID, showAlert, showPriceValue } from "../Settings/Settings";
var module = "sale/";
var moduleName = "Sale";
class Deliverychallan extends Component {
  constructor(props) {
    super(props);
    var saleID = this.props.match.params?.saleID || "";
    this.state = {
      userID: userID(),
      saleID: saleID,
      postdata: "",
      detaildata: [],
      pageloading: false,
    };
  }

  componentDidMount() {
    $("body").css("background", "#FFF");

    if (this.state.saleID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.saleID,
        url: module + "details",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      typeof nextProps.detaildata !== undefined &&
      typeof nextProps.detaildata !== "undefined" &&
      this.state.editID !== ""
    ) {
      if (nextProps.detaildata.length > 0) {
        this.setState({ detaildata: nextProps.detaildata }, function () {
          if (nextProps.detaildata[0].status === "ok") {
            var result = nextProps.detaildata[0].result;

            var clientupdatedata = {
              saleNumber: result.saleNumber,
              startDate: result.startDate,
              customer: {
                value: result.customerID,
                customerID: result.customerID,
                customerName: result.customerName,
                customerAddress1: result.customerAddress1,
                customerAddress2: result.customerAddress2,
                customerState: result.customerState,
                customerBranch: result.customerBranch,
                customerPincode: result.customerPincode,
                customerContactPerson: result.customerContactPerson,
                customerMobile: result.customerMobile,
                customerEmail: result.customerEmail,
                customerGSTNo: result.customerGSTNo,
                customerGSTCode: result.customerGSTCode,
              },
              typeofsale:
                result.saleType !== "Hardware"
                  ? { label: result.saleType, value: result.saleType }
                  : "",
              priviousTypeOfSale: result.saleType,
              brandID: "",
              warranty: "",
              salePaymentTerms: result.salePaymentTerms,
              products: result.salItem,
              taxItem: result.taxItem,
              totalPrice: result.salePrice,
              endDate:
                result.endDate !== ""
                  ? format(new Date(result.endDate), "dd-MM-yyyy")
                  : "",
              totalItem: result.totalItem,
              totalAmountWord: result.totalAmountWord,
              totalTaxAmount: result.totalTaxAmount,
              totalSingleTaxAmount: result.totalSingleTaxAmount,
              totalTaxAmountWord: result.totalTaxAmountWord,
              saleDeliveryNote: result.saleDeliveryNote,
              saleBuyerOrderNo: result.saleBuyerOrderNo,
              saleBuyerOrderDate:
                result.saleBuyerOrderDate !== ""
                  ? format(new Date(result.saleBuyerOrderDate), "dd-MM-yyyy")
                  : "",
              saleTermsofDelivery: result.saleTermsofDelivery,
            };
            this.setState(
              {
                postdata: clientupdatedata,
                pageloading: false,
              },
              () => {
                setTimeout(() => {
                  window.print();
                  window.onfocus = function () {
                    window.close();
                  };
                }, 100);
              }
            );
          } else {
            this.setState({ pageloading: false }, () => {
              this.props.history.push("/" + module);
              showAlert("Error", "Invalid" + moduleName, "error");
            });
          }
        });
      }
    }
  }

  render() {
    var postdata = this.state.postdata;
    return (
      <div>
        <div className="print-a4 container print-invoice">
          <div className="align-center">
            <h3>Delivery Challan</h3>
          </div>
          <table className="parant-tbl">
            <tr>
              <td>
                <table>
                  <tr>
                    <td width="50%">
                      <table className="addres-tbl">
                        <tr>
                          <td>
                            <div style={{ marginLeft: "3px" }}>
                              <b>RESMAX POWER TECH</b>
                              <br />
                              #17, Ground Floor, 40 Feet Road, KGF Munireddy
                              Layout, Mahadevapura, Bangalore- 560048
                              <br />
                              Recepient ID (K2) - 2903608503
                              <br />
                              GSTIN/UIN : 29AAZFR4823M1Z6
                              <br />
                              State Name : Karnataka, Code :29
                              <br />
                              GSTIN/UIN: 29AAZFR4823M1Z6
                              <br />
                              E-Mail : resmax@resmax.in
                              <br />
                            </div>
                          </td>
                        </tr>
                        <tr className="no-border-bottom">
                          <td className="no-border-top">
                            <div style={{ marginLeft: "3px" }}>
                              Buyer (Bill to)
                              <br />
                              <b>{postdata?.customer?.customerName}</b>
                              <br />
                              {postdata?.customer?.customerAddress1},{" "}
                              {postdata?.customer?.customerAddress2} -{" "}
                              {postdata?.customer?.customerPincode}
                              <br />
                              Ph No: {postdata?.customer?.customerMobile}
                              <br />
                              GSTIN/UIN : {postdata?.customer?.customerGSTNo}
                              <br />
                              State Name : {postdata?.customer?.customerState},
                              Branch : {postdata?.customer?.customerBranch},
                              Code : {postdata?.customer?.customerGSTCode}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td width="50%" valign="top">
                      <table className="invoice-tbl">
                        <tr>
                          <td>
                            Delivery Note No.
                            <br />
                            <b>{postdata?.saleNumber}</b>
                          </td>
                          <td className="no-border-top">
                            Dated
                            <br />
                            <b>{postdata.startDate}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Delivery Note
                            <br />
                            <b>{postdata.saleDeliveryNote}</b>
                          </td>
                          <td>
                            Mode/Terms of Payment
                            <br />
                            <b>{postdata?.salePaymentTerms}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Buyer's Order No.
                            <br />
                            <b>{postdata.saleBuyerOrderNo}</b>
                          </td>
                          <td>
                            Dated
                            <br />
                            <b>{postdata.saleBuyerOrderDate}</b>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="no-border-bottom">
                            Terms of Delivery
                            <br />
                            <b>{postdata.saleTermsofDelivery}</b>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <table className="invoice-item">
                  <thead>
                    <tr>
                      <th style={{ width: "2%" }} className="no-border-left">
                        SI No.
                      </th>
                      <th style={{ width: "57%" }}>Description of Goods</th>
                      <th style={{ width: "10%" }}>HSN/SAC</th>
                      <th style={{ width: "8%" }}>Quantity</th>
                      <th style={{ width: "10%" }}>Rate</th>
                      <th style={{ width: "10%" }} className="no-border-right">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {postdata?.products &&
                      postdata?.products.length > 0 &&
                      postdata?.products.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td valign="top" className="no-border-left">
                              {parseInt(index) + 1}
                            </td>
                            <td>
                              <b>{item.product.label}</b>
                              {item.description && (
                                <div style={{ marginLeft: "20px" }}>
                                  {item.description}
                                </div>
                              )}
                            </td>
                            <td valign="top">{item.productHSNSAC}</td>
                            <td align="right" valign="top">
                              {item.qty} No
                            </td>
                            <td align="right" valign="top"></td>
                            <td
                              align="right"
                              valign="top"
                              className="no-border-right"
                            ></td>
                          </tr>
                        );
                      })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="no-border-left"></td>
                      <td align="right">Total</td>
                      <td></td>
                      <td align="right">{postdata?.totalItem} No</td>
                      <td></td>
                      <td align="right" className="no-border-right"></td>
                    </tr>
                  </tfoot>
                </table>

                <table>
                  <tr>
                    <td style={{ width: "50%" }} valign="top">
                      <div style={{ marginLeft: "5px" }}>
                        Recd. in Good Condition
                      </div>
                    </td>
                    <td>
                      <table className="signatory-tbl no-border-top">
                        <tr>
                          <td align="right">
                            for <strong>RESMAX POWER TECH</strong>
                          </td>
                        </tr>
                        <tr>
                          <td align="right">
                            <div style={{ marginTop: "30px" }}>
                              Authorised Signatory
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <div className="align-center">
            This is a Computer Generated Document
          </div>
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Deliverychallan);
